<div class="article-search__search-field" data-testid="search-field">
  <dgx-form-search-select-article
    (searched)="onSearchedTerm($event)"
    [articles]="cs.articles$ | async"
    [placeholder]="placeholder"
    [title]="title"
  />
</div>
